import React, { useState, useEffect, useContext } from "react";
import {
  Grid,
  Container,
  makeStyles,
  TableBody,
  TableHead,
  TablePagination,
} from "@material-ui/core";
import {
  Loader,
  SimpleToolbar,
  Toast,
  Drawer,
  StyledTableCell,
  StyledTableRow,
  BaseTable,
} from "../components";
import { productsServices } from "../services";
import { AuthContext } from "../context";
import { useDrawer } from "../hooks";
import { handleDownloadExcel } from "../helpers";
export default function PatientsRepetitionRateScreen(props) {
  const classes = useStyles();
  const [assignments, setAssignments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [limit, setLimit] = useState(100);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const { authState, signOut } = useContext(AuthContext);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const { isOpen, setIsOpen } = useDrawer();
  const [tableHeader, setTableHeader] = useState([]);
  const [tableBody, setTableBody] = useState([]);

  useEffect(() => {
    setTableHeader([
      "RUT Paciente",
      "RUT Médico",
      "Nombre",
      "Producto",
      "N Asignaciones",
      "Primera Fecha de Asignación",
      "Ultima Fecha de Asignación",
    ]);

    const tableData = assignments.map((assignment) => {
      return [
         "*****" + assignment?.rut?.substring(5) || "",
         assignment.doctor.rut || "",
         `${assignment.doctor.name || ""} ${
          assignment.doctor.lastName || ""
        }`,
         assignment.product.name || "",
         assignment.count || "",
        
          new Date(assignment.createdAt).toLocaleDateString() || "",
        
          new Date(assignment.lastCreatedAt).toLocaleDateString() || "",
      ];
    });
    setTableBody(tableData);
  }, [assignments]);

  const getAssignments = async ({ text }) => {
    try {
      setLoading(true);
      const { status, response } =
        await productsServices.getPatientRepetitionRate({
          page,
          limit,
          laboratoryId: authState.user.laboratory._id,
          token: authState.token,
          text,
        });
      setLoading(false);
      if (status === 200) {
        setAssignments(response.assigments);
        setLimit(response.limit);
        setCount(response.total);
        setPage(response.page);
      } else if (status === 401) {
        signOut();
      } else if (response.error) {
        setToastMessage(response.error.message);
        setToast(true);
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  useEffect(() => {
    getAssignments({ text: " " });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit, authState]);
  const optionsToolbar = [
    {
      label: "Export excel",
      action: (e) => {
        handleDownloadExcel({
          filename: "Indice de repeticion de pacientes",
          tableHeader: tableHeader,
          tableBody: tableBody,
        });
      },
    },
  ];
  return (
    <>
      <Drawer open={isOpen} setOpen={(value) => setIsOpen(value)} />
      <Grid container className={classes.container} style={{ flex: 1 }}>
        {loading && <Loader loading={true} />}
        <Toast
          open={toast}
          message={toastMessage}
          close={() => setToast(false)}
        />
        <Grid item sm={12}>
          <div className={classes.root}>
            <Container maxWidth={false}>
              {
                <SimpleToolbar
                  hideExport={authState.user.laboratory}
                  // table={"tableassignments"}
                  // filename={"assignmentes"}
                  onFilter={(text) => getAssignments({ text })}
                  uploadassignments
                  isOpen={isOpen}
                  setIsOpen={(value) => setIsOpen(value)}
                  // tableHeader={tableHeader}
                  // tableBody={tableBody}
                  options={optionsToolbar}
                />
              }
              <BaseTable tableId="tableassignments">
                <TableHead>
                  <StyledTableRow>
                    {/* {authState.user.role.name === "LABORATORY_ADMIN" && <StyledTableCell>Unidad de negocio</StyledTableCell>} */}
                    <StyledTableCell>RUT Paciente</StyledTableCell>
                    {/* <StyledTableCell>Nombre</StyledTableCell> */}
                    {/* <StyledTableCell>Apellido</StyledTableCell> */}
                    <StyledTableCell>RUT Médico</StyledTableCell>
                    <StyledTableCell>Nombre</StyledTableCell>
                    {/* <StyledTableCell>Apellido</StyledTableCell> */}
                    <StyledTableCell>Producto</StyledTableCell>
                    <StyledTableCell>N Asignaciones</StyledTableCell>
                    <StyledTableCell>
                      Primera Fecha de Asignacion
                    </StyledTableCell>
                    <StyledTableCell>
                      Ultima Fecha de Asignacion
                    </StyledTableCell>
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  {assignments.map((assignment, index) => (
                    <StyledTableRow hover key={assignment._id}>
                      {/* {authState.user.role.name === "LABORATORY_ADMIN" && (
                        <StyledTableCell style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>
                          {assignment.laboratory.name}
                        </StyledTableCell>
                      )} */}

                      <StyledTableCell>
                        {/* {assignment.rut.charAt(assignment.rut.length - 2) === "-"
													? assignment.rut
													: `${assignment.rut.slice(0, assignment.rut.length - 1)}-${assignment.rut.slice(assignment.rut.length - 1)}`} */}
                        {"*****" + assignment.rut.substring(5)}
                      </StyledTableCell>
                      {/* <StyledTableCell style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>{assignment.firstName}</StyledTableCell> */}
                      {/* <StyledTableCell style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>{assignment.lastName}</StyledTableCell> */}
                      <StyledTableCell>
                        {/* {assignment.doctor.rut.charAt(assignment.doctor.rut.length - 2) === "-"
													? assignment.doctor.rut
													: `${assignment.doctor.rut.slice(0, assignment.doctor.rut.length - 1)}-${assignment.doctor.rut.slice(
														assignment.doctor.rut.length - 1
													)}`} */}
                        {assignment.doctor.rut}
                      </StyledTableCell>
                      <StyledTableCell>
                        {assignment.doctor.name} {assignment.doctor.lastName}
                      </StyledTableCell>
                      {/* <StyledTableCell style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>
												{assignment.doctor.lastName}
											</StyledTableCell> */}
                      <StyledTableCell>
                        {assignment.product.name}
                      </StyledTableCell>
                      <StyledTableCell>{assignment.count}</StyledTableCell>
                      <StyledTableCell>
                        {new Date(assignment.createdAt).toLocaleDateString()}
                      </StyledTableCell>
                      <StyledTableCell>
                        {new Date(
                          assignment.lastCreatedAt
                        ).toLocaleDateString()}
                      </StyledTableCell>
                      {/*!authState.user.laboratory && (
                          <StyledTableCell>{assignment.birthdate !== "Invalid date" ? assignment.birthdate : "N/A"}</StyledTableCell>
													<>
														<StyledTableCell>{assignment.phone ? assignment.phone : "N/A"}</StyledTableCell>
														<StyledTableCell>{assignment.activityPhone ? assignment.activityPhone : "N/A"}</StyledTableCell>
														<StyledTableCell>{assignment.email ? assignment.email : "N/A"}</StyledTableCell>
													</>
												)}
												<StyledTableCell>{assignment.specialties[0].name}</StyledTableCell>
												<StyledTableCell>{assignment.specialties[1] ? assignment.specialties[1].name : "N/A"}</StyledTableCell>
												<StyledTableCell>{assignment.specialties[2] ? assignment.specialties[2].name : "N/A"}</StyledTableCell>
												<StyledTableCell>{assignment.userId ? "Activo" : "Inactivo"}</StyledTableCell>
                    */}
                      {/* <StyledTableCell>
                                    <IconButton>
                                        <Tooltip title="Editar assignment" aria-label="edit">
                                        <Edit />
                                        </Tooltip>
                                    </IconButton>
                                    <IconButton>
                                        <Tooltip title='Activar assignment' aria-label="active">
                                        <CheckCircle />
                                        </Tooltip>
                                    </IconButton>
                                    <IconButton>
                                        <Tooltip title="Borrar assignment" aria-label="delete">
                                        <Delete />
                                        </Tooltip>
                                    </IconButton>
                                    </StyledTableCell> */}
                    </StyledTableRow>
                  ))}
                </TableBody>
              </BaseTable>
              <TablePagination
                labelRowsPerPage="Registros por página"
                component="div"
                count={count}
                onChangeRowsPerPage={(e) => {
                  setLimit(e.target.value);
                }}
                onChangePage={(e, page) => {
                  setPage(page + 1);
                }}
                page={page - 1}
                rowsPerPage={limit}
                rowsPerPageOptions={[10, 25, 50, 100]}
                classes={{ root: classes.pagination }}
              />
            </Container>
          </div>
        </Grid>
      </Grid>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
  },
  pagination: {
    color: theme.palette.secondary.main,
    [theme.breakpoints.down("xs")]: {
      position: "absolute",
      bottom: 0,
    },
  },
}));
